import { Column } from "../../../../core/components/Column";
import { CustomButton } from "../../../../core/components/CustomButton";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { calculateDate } from "../../../../core/constants/constants";
import { Check2 } from "../../../../core/icons/Check";
import { SubscriptionPlan } from "../../domain/entities/SubscriptionPlan";
import { UserSubscription } from "../../domain/entities/UserSubscription";

export const CardPlanSubscription = ({
	subscriptionsAll,
	selectedValue,
	onChange,
	subscription_id,
	subscriptionsByUser,
	setIsOpenWarning,
	handleAcceptSubscription,
	isLoading,
	free_subscription,
	status,
}: {
	subscriptionsAll: SubscriptionPlan[] | undefined;
	subscription_id: string;
	selectedValue: SubscriptionPlan | undefined;
	subscriptionsByUser: UserSubscription | undefined;
	onChange: (value: SubscriptionPlan | undefined) => void;
	setIsOpenWarning: React.Dispatch<React.SetStateAction<boolean>>;
	handleAcceptSubscription: () => void;
	isLoading: boolean;
	free_subscription: string;
	status: string;
}) => {
	const cardOptionsSubscriptionPlan = subscriptionsAll?.map((subscription: SubscriptionPlan, index) => {
		const isSelected = selectedValue?.id === subscription.id;
		return {
			id: subscription.id,
			name: subscription.name || "Undefined",
			price: subscription.price || 0,
			duration: subscription.duration || 1,
			type: subscription.type || "Undefined",
			description: subscription.description || "Undefined",
			paypal_plan_id: subscription.paypal_plan_id || "Undefined",
			isSelected,
		};
	})?.sort((a, b) => a.duration - b.duration);

	return (
		<>
			<Column>
				<TextComponent
					variant="h1"
					className="text-cyanPrimary font-semibold"
				>
					{subscriptionsByUser?.subscription_duration ? `Active Subscription` : "Subscribe now"}
				</TextComponent>
				<Row
					crossAxisAlignment="end"
					className="gap-1"
				>
					<TextComponent
						variant="h6"
						className="font-normal"
					>
						{subscriptionsByUser ? `Your plan expires on ${calculateDate(new Date(subscriptionsByUser.date_expiration))}` : "(Recurring until canceled)"}
					</TextComponent>
				</Row>
			</Column>
			<div className="w-full border-t border-primaryLight" />
			<Column className="text-black max-sm:gap-4 gap-2">
				{cardOptionsSubscriptionPlan && (
					<Column className="gap-4 select-none">
						{(subscription_id ? cardOptionsSubscriptionPlan.filter((card) => card.id === subscription_id) : cardOptionsSubscriptionPlan).map((card, index) => (
							<div key={index}>
								{!subscription_id && (
									<input
										type="radio"
										id={card.id}
										name="subscriptionOption"
										value={card.id}
										className="absolute opacity-0"
										onChange={() => onChange(card)}
										checked={card.isSelected}
										readOnly
									/>
								)}
								<label
									htmlFor={card.id}
									onClick={(event: React.MouseEvent<HTMLLabelElement>) => {
										if (subscription_id) return;
										event.preventDefault();
										onChange(card.isSelected ? undefined : card);
									}}
									className={`flex p-4 rounded-lg transition-colors items-center ${subscription_id ? "px-8" : "cursor-pointer"} bg-white`}
								>
									{!subscription_id && (
										<div className={`w-7 aspect-square rounded-full flex items-center justify-center mr-4 text-white border border-primary ${card.isSelected && "bg-primary"}`}>
											<Check2 />
										</div>
									)}
									<Column className="w-full">
										<Row
											mainAxisAlignment="between"
											className="font-semibold"
										>
											<TextComponent variant="h4">{card.duration}-Month Plan</TextComponent>
											<TextComponent
												variant="h4"
												className=" text-cyanPrimary"
											>
												{free_subscription === "ADMIN" ? "Free" : `${card.price} USD`}
											</TextComponent>
										</Row>
									</Column>
								</label>
							</div>
						))}
					</Column>
				)}
				{subscriptionsByUser ? (
					<>
						{free_subscription !== "ADMIN" && subscriptionsByUser.purchase_from === "PAYPAL" && 
							<CustomButton
								color="white"
								onClick={() => {
									setIsOpenWarning(true);
								}}
								className="mt-2"
								loading={isLoading}
								disabled={status !== "ACTIVE"}
							>
								{status === "ACTIVE" ? "Cancel Subscription" : "You canceled the subscription"}
							</CustomButton>
						}
					</>
				) : (
					<CustomButton
						onClick={handleAcceptSubscription}
						className="mt-2"
						loading={isLoading}
						disabled={!selectedValue}
					>
						Continue
					</CustomButton>
				)}
			</Column>
		</>
	);
};
